import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const Confirmationpopup = (props) => {
  return (
    props.visible && (
      <div className="fixed inset-0 z-50 w-screen h-screen overflow-y-auto bg-[rgba(211,211,211,0.2)] flex items-center justify-center px-4">
        <div
          className="w-[300px]   bg-themeColor border border-white/20 rounded-lg  gk-scr p-[20px]  flex items-center justify-center flex-col"
          style={props.style}
        >
          {props.picture && (
            <img
              loading="lazy"
              src={props.picture}
              className="w-[80px] h-[80px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg mb-[15px]"
            />
          )}
          <p className="text-center text-white">{props.text}</p>

          <div className="flex w-full justify-between items-center flex-row mt-[10px]">
            <button
              onClick={() => {
                props.accept();
              }}
              type="submit"
              className="text-center py-2 rounded-md  bg-themeblue hover:bg-themeblue/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase"
            >
              Yes
            </button>
            <button
              onClick={() => {
                props.cancel();
              }}
              type="submit"
              className="text-center py-2 rounded-md  bg-lighttextGray hover:bg-lighttextGray/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase"
            >
              No
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default Confirmationpopup;
